import React from 'react';
import { Container, Row } from 'react-bootstrap';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import DefaultTabsBorderedBottom from './component/DefaultTabsBorderedBottom';




const Meal = () => (
  <div>
    <Breadcrumbs
      style={{ marginLeft: '40px', marginBottom: '15px' }}
      aria-label="breadcrumb"
    >
      <Typography sx={{ color: 'text.primary' }}>Restaurant</Typography>
      <Typography sx={{ color: 'text.primary' }}>Meal</Typography>
      <Typography sx={{ color: 'text.primary' }}>Search</Typography>
    </Breadcrumbs>
    <Container>
      <Row>
        <DefaultTabsBorderedBottom />
      </Row>
    </Container>
  </div>
 
  );
export default Meal;
